import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2921be1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "LEI"),
    /*#__PURE__*/_createElementVNode("th", null, "Name der Entität"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "-1" }, "Fälligkeit nächste Verlängerung")
  ])
], -1))
const _hoisted_2 = { class: "leiStatus" }
const _hoisted_3 = { class: "tooltip" }
const _hoisted_4 = { class: "tooltiptext" }
const _hoisted_5 = {
  key: 0,
  class: "material-icons material-symbols-outlined",
  style: {"color":"green"}
}
const _hoisted_6 = {
  key: 1,
  class: "material-icons material-symbols-outlined",
  style: {"color":"orange"}
}
const _hoisted_7 = {
  key: 2,
  class: "material-icons material-symbols-outlined",
  style: {"color":"red"}
}
const _hoisted_8 = { key: 3 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "tooltip",
  style: {"height":"51px","display":"flex","flex-wrap":"nowrap","align-items":"center"}
}
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext" }, "Verlängern", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", null, [
    _hoisted_1,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leis, (lei, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: lei.registrationDetails.lei
        }, [
          _createElementVNode("td", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.StringUtil.capitalizeFirstLetter(lei.registrationDetails.status)), 1),
              (lei.registrationDetails.status === 'ISSUED')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " check_circle "))
                : (lei.registrationDetails.status === 'LAPSED')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " hourglass_bottom️ "))
                  : (lei.registrationDetails.status === 'RETIRED')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " warning "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8))
            ])
          ]),
          _createElementVNode("td", null, _toDisplayString(lei.registrationDetails.lei), 1),
          _createElementVNode("td", {
            onClick: ($event: any) => (_ctx.showDetails(lei.registrationDetails.lei))
          }, _toDisplayString(lei.legalEntity.legalName), 9, _hoisted_9),
          _createElementVNode("td", null, _toDisplayString(_ctx.StringUtil.formatDate(lei.registrationDetails.nextRenewal)), 1),
          _createElementVNode("td", {
            id: "leiExtend",
            class: _normalizeClass(
            _ctx.isInShoppingCart[index] ? 'leiExtend-disable' : 'leiExtend-enable'
          )
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "material-icons",
                onClick: _withModifiers(($event: any) => {
                _ctx.addItem(lei);
                _ctx.isInShoppingCart[index] = true;
              }, ["stop"]),
                disabled: _ctx.isInShoppingCart[index],
                style: {"text-align":"center"}
              }, " more_time ", 8, _hoisted_11),
              _hoisted_12
            ])
          ], 2)
        ]))
      }), 128))
    ])
  ]))
}